import * as React from 'react';
import { Link as Link$1 } from './Link.styles.js';

var Link = function (_a) {
    var children = _a.children, href = _a.href, _b = _a.underline, underline = _b === void 0 ? false : _b, _c = _a.size, size = _c === void 0 ? "m" : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.darkMode, darkMode = _e === void 0 ? false : _e, className = _a.className;
    return (React.createElement(Link$1, { href: href, underline: underline, size: size, disabled: disabled, darkMode: darkMode, role: "link", className: className }, children));
};

export { Link as default };
//# sourceMappingURL=Link.js.map
